import { render, staticRenderFns } from "./LL_Game.vue?vue&type=template&id=bfb6c804&scoped=true&"
import script from "./LL_Game.vue?vue&type=script&lang=js&"
export * from "./LL_Game.vue?vue&type=script&lang=js&"
import style0 from "./LL_Game.vue?vue&type=style&index=0&id=bfb6c804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb6c804",
  null
  
)

export default component.exports